import React from 'react';
import './footer.style.css';

const Footer = () => {
  return (
    <footer className='app-footer'><a href='https://ukgbc.org/' target="_blank">UKGBC</a></footer>
  )
}

export default Footer;